import {PredefinedOptionJson} from "../api/json/PredefinedOptionJson"

// Single source of truth for classification label colors. A palette change is a one-file edit here.
// Muted, desaturated hues (soft-tinted at render time) rather than saturated primaries.
export const CLASS_PALETTE = [
    "#0d9488", // teal
    "#7c3aed", // violet
    "#d97706", // amber
    "#db2777", // pink
    "#2563eb", // blue
    "#059669", // emerald
    "#dc2626", // red
    "#0891b2", // cyan
    "#ca8a04", // gold
    "#9333ea", // purple
]

export function resolveClassColor(value: string, options?: PredefinedOptionJson[]): string {
    const key = (value ?? "").trim().toLowerCase()
    const match = options?.find(option => option.value.trim().toLowerCase() === key)
    return match?.color ?? classColor(value)
}

export function classColor(value: string): string {
    const key = (value ?? "").trim().toLowerCase()
    let hash = 0
    for (let i = 0; i < key.length; i++) {
        hash = (hash * 31 + key.charCodeAt(i)) >>> 0
    }
    return CLASS_PALETTE[hash % CLASS_PALETTE.length]
}

// Correctness colors (soft-tinted at render time). Change here to restyle every match indicator.
export const RESULT_COLORS = {
    correct: "#059669",
    incorrect: "#e11d48",
}
